module.exports = __webpack_public_path__ + "img/home-app-image-en.f36c7d00.png";